import React from 'react'
import { OfficeList } from './office_list'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'

export const LandingPageBottom = ({offices, filter}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <section className={classes.container}> 
    <div className={classes.wrapper}>
        <OfficeList offices={offices} filter={filter || ""} />
    </div>
  </section>
  )
}

const useStyles = makeStyles({
  container: () => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    flex: '1 1 auto',
    maxHeight: '100%',
    overflow: 'auto'
  }),
  wrapper: theme => ({
    backgroundColor: theme.palette.background.main,
    height: '100%',
    display: 'flex',
    maxHeight: '100%',
    overflow: 'auto'
  })
})